
import {listClientUsers as listClientUsersGQL} from '../../../graphql/queries';
import {queryGqlApi} from "../../../graphql/queryGqlApi";
import { IDataClientService } from '../../../platform/services/data/DataClientService';
import { IAuthService } from '../../../platform/services/auth/AuthService';


export const listClientUsers = (
    dataClientService: IDataClientService,
    authService: IAuthService,
    nextToken?: string, 
    limit?: number
): Promise<any> => {
    return queryGqlApi(
        listClientUsersGQL,
        {
            limit: limit,
            nextToken: nextToken
        },
        dataClientService,
        authService,
        'main'
    );
}
